const SETTINGS_KEY = "device_settings";

export const getSettings = (): IDeviceSettings | undefined => {
  if (!window) {
    return undefined;
  }

  const serializedSettings = localStorage.getItem(SETTINGS_KEY);

  if (!serializedSettings) {
    console.warn("No settings were found for this device.");
  }

  return serializedSettings ? JSON.parse(serializedSettings) : undefined;
};

export const saveSettings = (settings: IDeviceSettings) => {
  if (!window) {
    throw new Error(`'window' is undefined.`);
  }

  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
};

export interface IDeviceSettings {
  id: string;
  os: "Android" | "iOS";
  clientId: string;
  currency: string;
  kioskUrl?: string;
}



// WEBPACK FOOTER //
// ./src/services/settings/index.ts